import { render, staticRenderFns } from "./LmTemplatePreviewModal.vue?vue&type=template&id=48791f7a"
import script from "./LmTemplatePreviewModal.vue?vue&type=script&lang=js"
export * from "./LmTemplatePreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports